// Shared day/night map theme. The map component owns the toggle, but other
// UI (legend/info bar) needs to follow it — so the value lives here and
// subscribers re-render via useSyncExternalStore.
export type MapTheme = 'dark' | 'light'

const KEY = 'rr-map-theme'

function readStoredTheme(): MapTheme {
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'
  } catch {
    return 'dark'
  }
}

let current: MapTheme = readStoredTheme()
const listeners = new Set<() => void>()

export function getMapTheme(): MapTheme {
  return current
}

export function setMapTheme(theme: MapTheme) {
  if (theme === current) return
  current = theme
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    /* private mode */
  }
  listeners.forEach((l) => l())
}

export function toggleMapTheme() {
  setMapTheme(current === 'dark' ? 'light' : 'dark')
}

export function subscribeMapTheme(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
